var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"show-img"}},[(_vm.ModifiedImgData.length != 0)?_c('img',{attrs:{"src":_vm.getCurrentImgSrc,"alt":""}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }